import { render, staticRenderFns } from "./Alert2.vue?vue&type=template&id=05eee815&"
import script from "./Alert2.vue?vue&type=script&lang=js&"
export * from "./Alert2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports